// extracted by mini-css-extract-plugin
export var disabled = "_1a-a";
export var hierarchyLinkGray = "_1a-4";
export var hierarchyLinkUnderline = "_1a-3";
export var hierarchyPrimary = "_1a-0";
export var hierarchySecondary = "_1a-1";
export var hierarchyTertiary = "_1a-2";
export var pressed = "_1a-6";
export var themeAction = "_1a-5";
export var themeDestructive = "_1a-8";
export var themeNormal = "_1a-7";
export var themeSuccess = "_1a-9";